//
const weImage = require('common/pc/images/we_banner.png')
// 公司简介
const imagePicture = require('common/pc/images/image_picture.png')
const leagueBuilding01 = require('common/pc/images/league_building_01.png')
const leagueBuilding02 = require('common/pc/images/league_building_02.png')
const leagueBuilding03 = require('common/pc/images/league_building_03.png')
// 发展史
const courseBackground = require('common/pc/images/course_background.png')
const content = '本司2018年成立于中国香港，我们风雨兼程历时多年打造核心团队，从自媒体运营到编程实验室，一路见证国内主内互联网行业的此起彼伏公司致力打造具有主内文化特色、以基督信仰生活为基础的新时代互联网生态的产品。根植信仰原则、福音使命、支持教会互联网新需求和倍增文化为目标砥砺前行。'
const data = {
  coverImg: weImage,
  detail: {
    title: '公司简介',
    contentImg: imagePicture,
    content: content,
    imgList: [
      {
        img: leagueBuilding01
      },
      {
        img: leagueBuilding02
      },
      {
        img: leagueBuilding03
      }
    ]
  },
  history: [
    {
      date: '至今',
      bakImg: courseBackground,
      detail: [
        {
          item: '敲门砖'
        },
        {
          item: '圣经APP'
        },
        {
          item: 'In Him'
        },
        {
          item: '福音广告'
        },
        {
          item: '组长助手'
        }
      ]
    },
    {
      date: '2019',
      bakImg: courseBackground,
      detail: [
        {
          item: '圣经APP问世'
        },
        {
          item: '福音广告开始测试'
        },
        {
          item: '产品技术部成立、更名“因他科技”'
        }
      ]
    },
    {
      date: '2018',
      bakImg: courseBackground,
      detail: [
        {
          item: '附近的教堂小程序首次上线'
        },
        {
          item: '教会通问世'
        },
        {
          item: '恩典365H'
        }
      ]
    },
    {
      date: '2013-2017',
      bakImg: courseBackground,
      detail: [
        {
          item: '主内云团队建立'
        },
        {
          item: '成立媒体部，第一批公众号开始运营'
        }
      ]
    }
  ]
}
export default data



// WEBPACK FOOTER //
// ./src/common/pc/js/aboutUs.js